var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import DashboardIcon from '@mui/icons-material/Dashboard';
import { useBasename } from 'ra-core';
import { MenuItemLink } from './MenuItemLink';
export var DashboardMenuItem = function (props) {
    var basename = useBasename();
    var _a = props.leftIcon, leftIcon = _a === void 0 ? React.createElement(DashboardIcon, null) : _a, _b = props.to, to = _b === void 0 ? "".concat(basename, "/") : _b, _c = props.primaryText, primaryText = _c === void 0 ? 'ra.page.dashboard' : _c, rest = __rest(props, ["leftIcon", "to", "primaryText"]);
    return (React.createElement(MenuItemLink, __assign({ leftIcon: leftIcon, to: to, primaryText: primaryText }, rest)));
};
DashboardMenuItem.propTypes = {
    leftIcon: PropTypes.element,
    locale: PropTypes.string,
    onClick: PropTypes.func,
    dense: PropTypes.bool,
    sidebarIsOpen: PropTypes.bool,
};
//# sourceMappingURL=DashboardMenuItem.js.map